import { getRateInAllFormats } from '@transferwise/formatting';
import PropTypes from 'prop-types';
import React from 'react';

const CurrencyRouteDescription = ({ sourceCurrency, targetCurrency, exchangeRate, multiplier }) => {
  const defaultedExchangeRate = exchangeRate || 1; // required as exchangeRate is mandatory in getRateInAllFormats
  const isInvertedRate =
    getRateInAllFormats(defaultedExchangeRate, sourceCurrency, targetCurrency).formats.equation
      .reference === 'target';

  return (
    <>
      {'('}
      {multiplier} {isInvertedRate ? targetCurrency : sourceCurrency} {'→'}{' '}
      {isInvertedRate ? sourceCurrency : targetCurrency}
      {')'}
    </>
  );
};

CurrencyRouteDescription.propTypes = {
  sourceCurrency: PropTypes.string.isRequired,
  targetCurrency: PropTypes.string.isRequired,
  exchangeRate: PropTypes.number,
  multiplier: PropTypes.number,
};

CurrencyRouteDescription.defaultProps = {
  exchangeRate: null,
  multiplier: 1,
};

export default CurrencyRouteDescription;
